import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const initialFormData = {
    completedAllProcedures: null,
    reasonForNonCompletion: '',
    screenFailureReason: {
      inclusionCriteriaNotMet: false,
      exclusionCriteriaNotMet: false,
      lostToFollowUp: false,
      withdrawalBySubject: false,
      protocolDeviation: false,
      physicianDecision: false,
      pregnancy: false,
      other: false
    },
    earlyTerminationReason: {
      adverseEvent: false,
      lostToFollowUp: false,
      pregnancy: false,
      withdrawalBySubject: false,
      protocolDeviation: false,
      physicianDecision: false,
      other: false
    },
    otherReason: '',
    inclusionCriteriaNotMet: '',
    exclusionCriteriaNotMet: '',
    adverseEvent: '',
    protocolDeviation: '',
    otherScreenFailureReason: '',
    otherEarlyTerminationReason: '',
  };

const StudyCompletionModal = ({ isOpen, toggle, subjectId, onStudyCompleted }) => {
    const [formData, setFormData] = useState(initialFormData);

    useEffect(() => {
        if (!isOpen) {
          setFormData(initialFormData);
        }
      }, [isOpen]);
  const handleInputChange = (name, value, type, checked ) => {
    if (type === 'checkbox') {
      const [category, reason] = name.split('.');
      setFormData(prev => ({
        ...prev,
        [category]: {
          ...prev[category],
          [reason]: checked
        }
      }));
    } else if (name === 'completedAllProcedures') {
        setFormData(prev => ({
          ...initialFormData,
          completedAllProcedures: value
        }));
      } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
    console.log("Form Data: ",formData)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();



    try {
      const response = await axios.post(`${BASE_URL}web/completeStudy`, { patientId: subjectId, ...formData });
      if (response.data.success) {
        onStudyCompleted();
        toggle();
      } else {
        alert(`Error completing study: ${response.data.message}`);
      }
    } catch (error) {
      alert(`Error completing study: ${error.message}`);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
      <ModalHeader toggle={toggle}>Subject Completion Status</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <FormGroup tag="fieldset">
            <legend>Did the subject complete all procedures per protocol?</legend>
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="completedAllProcedures"
                  value="yes"
                  checked={formData.completedAllProcedures === 'yes'}
                  onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, e.target.checked)}
                  required
                /> YES
              </Label>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="completedAllProcedures"
                  value="no"
                  checked={formData.completedAllProcedures === 'no'}
                  onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, e.target.checked)}
                  required
                /> NO
              </Label>
            </FormGroup>
          </FormGroup>

          {formData.completedAllProcedures === 'no' && (
            <FormGroup>
              <Label>If NO:</Label>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="reasonForNonCompletion"
                    value="screenFailure"
                    checked={formData.reasonForNonCompletion === 'screenFailure'}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, e.target.checked)}
                  /> Screen Failure
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="reasonForNonCompletion"
                    value="earlyTermination"
                    checked={formData.reasonForNonCompletion === 'earlyTermination'}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, e.target.checked)}
                  /> Early Termination
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="reasonForNonCompletion"
                    value="other"
                    checked={formData.reasonForNonCompletion === 'other'}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, e.target.checked)}
                  /> Other:
                </Label>
                <Input
                  type="text"
                  name="otherReason"
                  value={formData.otherReason}
                  onChange={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, e.target.checked)}
                  disabled={formData.reasonForNonCompletion !== 'other'}
                />
              </FormGroup>
            </FormGroup>
          )}

          {formData.reasonForNonCompletion === 'screenFailure' && (
            <FormGroup>
              <Label>If Screen Failure, Reason:</Label>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="screenFailureReason.inclusionCriteriaNotMet"
                    checked={formData.screenFailureReason.inclusionCriteriaNotMet}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.screenFailureReason.inclusionCriteriaNotMet)}
                  /> Inclusion criteria not met:
                </Label>
                <Input
                  type="text"
                  name="inclusionCriteriaNotMet"
                  value={formData.inclusionCriteriaNotMet}
                  onChange={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, e.target.checked)}
                  placeholder="specify #"
                  disabled={!formData.screenFailureReason.inclusionCriteriaNotMet}
                />
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="screenFailureReason.exclusionCriteriaNotMet"
                    checked={formData.screenFailureReason.exclusionCriteriaNotMet}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.screenFailureReason.exclusionCriteriaNotMet)}
                  /> Exclusion criteria not met:
                </Label>
                <Input
                  type="text"
                  name="exclusionCriteriaNotMet"
                  value={formData.exclusionCriteriaNotMet}
                  onChange={(e) =>handleInputChange(e.target.name,e.target.value,e.target.type,e.target.checked)}
                  placeholder="specify #"
                  disabled={!formData.screenFailureReason.exclusionCriteriaNotMet}
                />
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="screenFailureReason.lostToFollowUp"
                    checked={formData.screenFailureReason.lostToFollowUp}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.screenFailureReason.lostToFollowUp)}
                  /> Lost to follow up
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="screenFailureReason.withdrawalBySubject"
                    checked={formData.screenFailureReason.withdrawalBySubject}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.screenFailureReason.withdrawalBySubject)}
                  /> Withdrawal by subject
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="screenFailureReason.protocolDeviation"
                    checked={formData.screenFailureReason.protocolDeviation}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.screenFailureReason.protocolDeviation)}
                  /> Protocol deviation
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="screenFailureReason.physicianDecision"
                    checked={formData.screenFailureReason.physicianDecision}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.screenFailureReason.physicianDecision)}
                  /> Physician decision
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="screenFailureReason.pregnancy"
                    checked={formData.screenFailureReason.pregnancy}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.screenFailureReason.pregnancy)}
                  /> Pregnancy
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="screenFailureReason.other"
                    checked={formData.screenFailureReason.other}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.screenFailureReason.other)}
                  /> Other:
                </Label>
                <Input
                  type="text"
                  name="otherScreenFailureReason"
                  value={formData.otherScreenFailureReason}
                  onChange={(e) => handleInputChange(e.target.name, e.target.value, e.target.type,e.target.checked)}
                  placeholder="specify"
                  disabled={!formData.screenFailureReason.other}
                />
              </FormGroup>
            </FormGroup>
          )}

          {formData.reasonForNonCompletion === 'earlyTermination' && (
            <FormGroup>
              <Label>If Early Term, Reason:</Label>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="earlyTerminationReason.adverseEvent"
                    checked={formData.earlyTerminationReason.adverseEvent}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.earlyTerminationReason.adverseEvent)}
                  /> Adverse event:
                </Label>
                <Input
                  type="text"
                  name="adverseEvent"
                  value={formData.adverseEvent}
                  onChange={(e) =>handleInputChange(e.target.name,e.target.value,e.target.type, e.target.clicked)}
                  placeholder="specify"
                  disabled={!formData.earlyTerminationReason.adverseEvent}
                />
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="earlyTerminationReason.lostToFollowUp"
                    checked={formData.earlyTerminationReason.lostToFollowUp}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.earlyTerminationReason.lostToFollowUp)}
                  /> Lost to follow-up
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="earlyTerminationReason.pregnancy"
                    checked={formData.earlyTerminationReason.pregnancy}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.earlyTerminationReason.pregnancy)}
                  /> Pregnancy
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="earlyTerminationReason.withdrawalBySubject"
                    checked={formData.earlyTerminationReason.withdrawalBySubject}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.earlyTerminationReason.withdrawalBySubject)}
                  /> Withdrawal by subject
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="earlyTerminationReason.protocolDeviation"
                    checked={formData.earlyTerminationReason.protocolDeviation}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.earlyTerminationReason.protocolDeviation)}
                  /> Protocol deviation:
                </Label>
                <Input
                  type="text"
                  name="protocolDeviation"
                  value={formData.protocolDeviation}
                  onChange={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, e.target.clicked)}
                  placeholder="specify"
                  disabled={!formData.earlyTerminationReason.protocolDeviation}
                />
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="earlyTerminationReason.physicianDecision"
                    checked={formData.earlyTerminationReason.physicianDecision}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.earlyTerminationReason.physicianDecision)}
                  /> Physician decision
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="earlyTerminationReason.other"
                    checked={formData.earlyTerminationReason.other}
                    onClick={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, !formData.earlyTerminationReason.other)}
                  /> Other:
                </Label>
                <Input
                  type="text"
                  name="otherEarlyTerminationReason"
                  value={formData.otherEarlyTerminationReason}
                  onChange={(e) => handleInputChange(e.target.name, e.target.value, e.target.type, e.target.clicked)}
                  placeholder="specify"
                  disabled={!formData.earlyTerminationReason.other}
                />
              </FormGroup>
            </FormGroup>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Cancel</Button>
          <Button color="primary" type="submit">Submit</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default StudyCompletionModal;